import { render } from "./DocumentsFromAttorney.vue?vue&type=template&id=6dcdcacf&scoped=true"
import script from "./DocumentsFromAttorney.vue?vue&type=script&lang=js"
export * from "./DocumentsFromAttorney.vue?vue&type=script&lang=js"

import "./DocumentsFromAttorney.vue?vue&type=style&index=0&id=6dcdcacf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dcdcacf"]])

export default __exports__